import React from 'react';
import intl from 'react-intl-universal';
import { Tabs, Upload, Button, Input, Spin, Divider } from 'antd';
import { convertUTCToLocale, getFileSize, /* handlerFileNameWithoutExtension, */ isCNDomain } from 'Utils/utils';
import Drives from 'Components/drives_panel/Drives';
import FwDocs from '@/components/fwDocsIframe/fwDocsIframe'//TODO FOXIT 云文档
import {store} from 'Store/store.index';
import { GOOGLE_DRIVE, ONE_DRIVE, BOX, DROP_BOX, iManage, /* RECENT_BOX, DOCUMENT_BOX, FOXIT_STORAGE */ } from 'Api/drives.constants';
import { isValidURL } from 'Utils/utils';
import {
  OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_URL,
  /*OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,*/
  // OPEN_FILE_FROM_DRIVES,
  // OPEN_FILE_FROM_PRIVATE_DRIVE,
  // OPEN_FILE_FROM_IMANAGE,
  // OPEN_FILE_FROM_RECENT,
  // OPEN_FILE_FROM_DOCUMENTS,
} from 'Components/viewer/ui/constants/openfile.constants';
/* import {
  SAVE_TO_LOCAL,
  SAVE_TO_DOWNLOAD,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_DRIVES,
  SAVE_TO_PRIVATE_DRIVE,
} from 'Components/viewer/ui/constants/savefile.constants'; */
import './CommonPanel.scss';
// import LOCAL_COMPUTER from '../images/computer_color.svg';
// import ONE_DRIVE_GRAY from '@/assets/OpenSaveCombine/onedrive-gray.svg';
// import BOX_GRAY from '@/assets/OpenSaveCombine/box-gray.svg';
import PDF_FILE from '@/assets/OpenSaveCombine/pdf-file.svg';
import LOCAL_COMPUTER from '@/assets/OpenSaveCombine/localComputer.svg';
import { DATA_TYPE, FileData } from 'Api/index';
import { COMBINE_FILE_SIZE_LIMIT } from '@/limit.constant';
import getSaveAsTabPan from './SaveAs';
import {observer} from "mobx-react";
import StorageTable from '../../../Storage/Table';
// import { iManageService } from '@/store/services/index';
//import cuid from 'cuid';
import withAriaTabs from '@/components/Aria/AriaTab'; 

const AriaTabs = withAriaTabs(Tabs);
const { TabPane } = Tabs;
const { Dragger } = Upload;

@observer
class CommonPanel extends React.Component {
  /**
   *Creates an instance of CommonPanel.
   * @param {Object} props
   * @param {ConvertController} props.convertController
   * @memberof CommonPanel
   */
  constructor(props) {
    super(props);

    this.LocalComputer = intl.formatMessage({ id: 'CommonPanel.LocalComputer' });
    //TODO FOXIT 云文档
    this.cloudDocs = intl.formatMessage({ id: 'CommonPanel.cloudDocs' });
    this.Url = intl.formatMessage({ id: 'CommonPanel.Url' });
    this.OneDrive = intl.formatMessage({ id: 'CommonPanel.OneDrive' });
    this.Box = intl.formatMessage({ id: 'CommonPanel.Box' });
    this.DropBox = intl.formatMessage({ id: 'CommonPanel.DropBox' });
    this.GoogleDrive = intl.formatMessage({ id: 'CommonPanel.GoogleDrive' });
    this.DropFileHere = intl.formatMessage({ id: 'CommonPanel.DropFileHere' });
    this.ClickOrDropFileHere = intl.formatMessage({ id: 'CommonPanel.ClickOrDropFileHere' });
    this.Download = intl.formatMessage({ id: 'CommonPanel.Download' });
    this.SaveToLocalComputer = intl.formatMessage({ id: 'CommonPanel.SaveToLocalComputer' });
    this.ClickToUpload = intl.formatMessage({ id: 'CommonPanel.ClickToUpload' });
    this.ChooseFile = intl.formatMessage({ id: 'CommonPanel.ChooseFile' });
    this.EnterThePdfFileUrl = intl.formatMessage({ id: 'CommonPanel.EnterThePdfFileUrl' });
    this.Cancel = intl.formatMessage({ id: 'CommonPanel.Cancel' });
    this.Open = intl.formatMessage({ id: 'CommonPanel.Open' });
    this.AddFilesSuccess = intl.formatMessage({ id: 'CombineFiles.Msg.AddFilesSuccess' });
    this.PreviousStep = intl.formatMessage({ id: 'CommonPanel.PreviousStep' });
    this.InputValidUrl = intl.formatMessage({ id: 'CommonPanel.InputValidUrl' });
    this.SingleFileSizeOver = intl.formatMessage({ id: 'CombineFiles.Msg.SingleFileSizeOver' });
    this.OpenLocalTabTitle = intl.formatMessage({ id: 'CommonPanel.OpenLocalTabTitle' });
    this.SaveLocalTabTitle = intl.formatMessage({ id: 'CommonPanel.SaveLocalTabTitle' });
    this.OpenOtherTabTitle = intl.formatMessage({ id: 'CommonPanel.OpenOtherTabTitle' });
    this.SaveOtherTabTitle = intl.formatMessage({ id: 'CommonPanel.SaveOtherTabTitle' });

    this.commonDrivesProps = {
      type: 'panel',
      previousStep: this.props.previousStep,
      operateType: this.props.operateType,
      modalType: this.props.modalType,
      openFileInfo: this.props.openFileInfo,
      customInfo: this.props.customInfo,
      visible: true,
      openFileCallback: this.props.openFileCallback,
      saveSucceedCallback: this.props.saveSucceedCallback,
      onCancel: this.props.onCancel,
      onUploadFileFailedCallback: this.props.onUploadFileFailedCallback,
    };

    this.tabPansArr = [];

    this.state = {
      tabPansArr: null,
      // activeKey: props.activeKey,
      addedFilesNum: 0,
      fileUrl: null,
      isSpin: false,
      netDriverIcon:[],
      activeKey: this.props.activeKey
    };

    this.initTabPans = this.initTabPans.bind(this);
    this.initExternalTabPans = this.initExternalTabPans.bind(this);
    this.getLocalComputerContentDom = this.getLocalComputerContentDom.bind(this);
    this.getCloudDocsContentDom = this.getCloudDocsContentDom.bind(this);
    this.getOneDriveContentDom = this.getOneDriveContentDom.bind(this);
    this.getBoxContentDom = this.getBoxContentDom.bind(this);
    this.getDropboxContentDom = this.getDropboxContentDom.bind(this);
    this.getGoogleDriveContentDom = this.getGoogleDriveContentDom.bind(this);
    this.onBeforeUploadForLocalComputer = this.onBeforeUploadForLocalComputer.bind(this);
    this.onUploadFilesForLocalComputer = this.onUploadFilesForLocalComputer.bind(this);
    this.onChangeSelectedFiles = this.onChangeSelectedFiles.bind(this);
    this.onChangeSelectedLocalFile = this.onChangeSelectedLocalFile.bind(this);
    this.getUrlContentDom = this.getUrlContentDom.bind(this);
    this.onChangeFileUrl = this.onChangeFileUrl.bind(this);
    this.onOpenUrlFile = this.onOpenUrlFile.bind(this);
    this.onDriverContentDom = this.onDriverContentDom.bind(this);
    this.getSaveAndOpenTabPans = this.getSaveAndOpenTabPans.bind(this);
  }
  componentWillUnmount () {
    this.setState = () => false;
  }
  onDriverContentDom(item){
    return (
      <React.Fragment>
        <div className="drives-content">
          {/* <div className="header-wrapper">{this.DropBox}</div> */}
          <Drives type="panel" driveName={item.netDriverTabPan.key} driverTitle={item.netDriverTabPan.tab.title} {...this.commonDrivesProps} />
        </div>
      </React.Fragment>
    );
  }
  // 外部网盘 获取焦点时事件
  onTabNetDriverSelected(item,i){
    store.netDriverStore.drivers[i].icon.currentIcon = item.icon.selected
  }
  // 外部网盘 焦点移除时事件
  onTabNetDriverNormal(item,i){
    store.netDriverStore.drivers[i].icon.currentIcon = item.icon.normal
  }
  initExternalTabPans(){
    // 获取外部插件网盘列表
    let netDrivers = [];
    // let { testSrc } = store.netDriverStore
    for (let i = 0; i < store.netDriverStore.drivers.length; i++) {
      let item = store.netDriverStore.drivers[i];
      netDrivers.push(
          {
            key: item.driverId,
            category: 'otherNet',
            tab: (
                <React.Fragment>
                  <div>
                  <i className="plugin-tab-icon tab-icon m-r-8" style={{background:`url(${item.icon.normal}) no-repeat 0 0/100% 100%`}} />
                  <i className="plugin-tab-icon-selected tab-icon m-r-8" style={{background:`url(${item.icon.selected}) no-repeat 0 0/100% 100%`}} />
                  <span>{item.netDriverTabPan.tab.title}</span>
                  </div>
                </React.Fragment>
            ),
            content: this.onDriverContentDom(item),
          }
      )
    }
    return netDrivers;
  }
  // ! 保存文件弹窗，online当前支持本地、oneDrive、Box、Dropbox、google Drive
  // TODO FOXIT 云编辑去除oneDrive、Box、Dropbox、google Drive存储。
  initTabPans() {
    const localComputerTabPan = {
      key: 'LOCAL_COMPUTER',
      category: 'local',
      tab: (
        <React.Fragment>
          <i className="local-computer tab-icon m-r-8" />
          <span className="tab-text">{this.LocalComputer}</span>
        </React.Fragment>
      ),
      content: this.getLocalComputerContentDom(),
    };
    // TODO FOXIT 云文档
    const cloudDocsTabPan = {
      key: 'CLOUD_DOCS',
      tab: (
        <React.Fragment>
          <i className="local-computer tab-icon m-r-5" />
          <span className="tab-text">{this.cloudDocs}</span>
        </React.Fragment>
      ),
      content: this.getCloudDocsContentDom()
    };
    const urlTabPan = {
      key: 'Url',
      tab: (
        <React.Fragment>
          <i className="url tab-icon m-r-5"></i>
          <span className="tab-text">{this.Url}</span>
        </React.Fragment>
      ),
      content: this.getUrlContentDom(),
    };

    // const recentFilesTabPan = {
    //   key: RECENT_BOX,
    //   tab: (
    //     <React.Fragment>
    //       <i className="recent-files tab-icon m-r-5" />
    //       <span>{intl.get('toolbar.buttons.recentFiles')}</span>
    //     </React.Fragment>
    //   ),
    //   content: (
    //     <React.Fragment>
    //       <div className="recent-files-content">
    //         <StorageTable tabs={['Recent']} mini={true} multiple={false} onOpenFile={()=>{
    //           store.appStore.hideOpenFileDlg()
    //         }}></StorageTable>
    //       </div>
    //     </React.Fragment>
    //   )
    // };

    // const documentsTabPan = {
    //   key: DOCUMENT_BOX,
    //   tab: (
    //     <React.Fragment>
    //       <i className="documents tab-icon m-r-5" />
    //       <span>{intl.get('toolbar.buttons.documents')}</span>
    //     </React.Fragment>
    //   ),
    //   content: (
    //     <React.Fragment>
    //       <div className="documents-content">
    //         <StorageTable tabs={['Documents']} pagabled={true} mini={true} multiple={this.props.operateType==='add'} onOpenFile={()=>{
    //           store.appStore.hideOpenFileDlg()
    //         }}></StorageTable>
    //       </div>
    //     </React.Fragment>
    //   ),
    // };

    // const saveToFoxitStorageTabPan = {
    //   key: FOXIT_STORAGE,
    //   tab: (
    //     <React.Fragment>
    //       <i className="save-to-foxit-storage tab-icon m-r-5" />
    //       <span>{intl.get('toolbar.buttons.documents')}</span>
    //     </React.Fragment>
    //   ),
    //   content: this.getSaveToFoxitStorageTabPan(),
    // };

    if (this.props.operateType === 'save' && this.props.customInfo && this.props.customInfo.isFromExeUpload) {
      return [saveToFoxitStorageTabPan];
    }

    if (isCNDomain()) {
      if (this.props.operateType === 'open') {
        return [localComputerTabPan];
      } else {
        return [localComputerTabPan, getSaveAsTabPan({ onSaveAs: this.props.onSaveAs })];
      }
    } else {
      const { invisibleOpenSaveBtn } = store.userStore;
      // const { isOnPremiseDeployMode } = store.appStore;
      const filterBtn = [];

      if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_LOCAL) > -1 || this.props.hideLocal || !!this.props.customInfo) {
        // filterBtn.push(localComputerTabPan);
      }
      if (invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_URL) > -1) {
        filterBtn.push(urlTabPan);
      }
      // TODO FOXIT 云编辑去除oneDrive、Box、Dropbox、google Drive存储。
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_ONE_DRIVE) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(oneDriveTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_RECENT) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(recentFilesTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_DOCUMENTS) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(documentsTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_BOX) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(boxTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_DROPBOX) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(dropboxTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_GOOGLE_DRIVE) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(googleDriveTabPan);
      // }
      // if ((invisibleOpenSaveBtn.indexOf(OPEN_FILE_FROM_IMANAGE) > -1)&&!isOnPremiseDeployMode) {
      //   filterBtn.push(iManageTabPan);
      // }

      if (this.props.operateType === 'open') {
        // TODO FOXIT 云编辑去除oneDrive、Box、Dropbox、google Drive存储。 新增云文档
        const tabPansArr = [localComputerTabPan, cloudDocsTabPan];
        // let tabPansArr = !isOnPremiseDeployMode?[localComputerTabPan /* , urlTabPan */, oneDriveTabPan, boxTabPan, dropboxTabPan, googleDriveTabPan,...netDrivers]:[localComputerTabPan];
        const tabPansVisible = tabPansArr.filter((item) => {
          if (filterBtn.indexOf(item) < 0) {
            return true;
          }
        });

        return tabPansVisible;
      } else {
        // TODO FOXIT 云编辑去除oneDrive、Box、Dropbox、google Drive存储。新增云文档
        const tabPansArr = [localComputerTabPan, cloudDocsTabPan];
        // const tabPansArr = [localComputerTabPan,  getSaveAsTabPan({ onSaveAs: this.props.onSaveAs }), oneDriveTabPan, boxTabPan, dropboxTabPan, googleDriveTabPan,...netDrivers, iManageTabPan];
        // if (store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage) {
        //   tabPansArr.splice(2, 0, saveToFoxitStorageTabPan);
        // }
        const tabPansVisible = tabPansArr.filter((item) => {
          if (filterBtn.indexOf(item) < 0) {
            return true;
          }
        });

        return tabPansVisible;
      }
    }
  }
  onUploadFilesForLocalComputer() {

  }
  onBeforeUploadForLocalComputer(file, fileList) {
    file.id = file.uid;

    let fileOverSize = fileList.some((item) => {
      if (item.size / 1024 / 1024 > COMBINE_FILE_SIZE_LIMIT) {
        return true;
      }
    });

    if (fileOverSize) {
      store.appStore.setGlobalMessage({ type: 'error', content: this.SingleFileSizeOver });

      return;
    }

    const taskCreateSuccess = (result) => {
      this.props.onAddFilesForCombineCallback(result);

      // store.appStore.setGlobalMessage({ type: 'success', content: this.AddFilesSuccess });

      this.setState(
        (state) => ({
          addedFilesNum: state.addedFilesNum + 1,
        }),
        () => {
          const { addedFilesNum } = this.state;

          if (addedFilesNum === fileList.length) {
            setTimeout(() => {
              this.props.previousStep();
            });
          }
        },
      );
    };
    const fileData = new FileData(file, file.name, DATA_TYPE.File, '', file.uid);
    const taskList = store.taskStore.doUploadMultiFiles([fileData], (result) => {
      // {ret :1, msg :'Error.UploadingFile.fail', list:[{id:fileUid,taskId:taskUpload.id}]}
      const { ret, msg, list } = result;

      if (ret === 1 && msg === 'Error.UploadingFile.fail') {
        this.props.onUploadFileFailedCallback(list);
      }
    });
    if (taskList.length === 0) {
      return false;
    }

    taskList.forEach((item) => {
      [fileData].some((innerItem) => {
        const { file } = innerItem;

        if (item.id === file.id) {
          item.name = file.name;
          item.modifiedTime = convertUTCToLocale(file.lastModified).substring(0, 10);
          item.size = getFileSize(file.size);

          return true;
        }
      });
    });

    taskCreateSuccess(taskList);

    return false;
  }
  onChangeSelectedFiles(/* { file, fileList } */) {
    // file.id = file.uid;
    // file.modifiedTime = convertUTCToLocale(file.lastModified)
    // file.size = getFileSize(file.size)
    return false;
  }
  onChangeSelectedLocalFile({ file }) {
    const {
      openFileDlg: { isForAi, resolveFileListToAiPlugin },
    } = store.appStore;

    if (isForAi) {
      const files = [
        {
          id: file.uid,
          name: file.name,
          size: file.size,
          drive: 'local',
          blob: file.originFileObj,
        },
      ];

      store.appStore.setOpenFileDlgChangeLoadingState((isLoading) => {
        if (isLoading) {
          this.setState({
            isSpin: true,
          });
        } else {
          this.setState({
            isSpin: false,
          });
        }
      });
      resolveFileListToAiPlugin && resolveFileListToAiPlugin(files);
      // const {aipluginUploadCallback} = store.appStore.aipluginUploadCallback;
      // let files = []; let file= {id: info.id, name: info.fileName , size: info.fileSize}; files.push(file)
      // aipluginUploadCallback && aipluginUploadCallback(files);
    } else {
      this.props.onOpenFileForLocalComputer({ file: file.originFileObj });
    }
  }
  onOpenUrlFile() {
    if (isValidURL(this.state.fileUrl)) {
      this.props.onOpenFileForUrl({ url: this.state.fileUrl });
    } else {
      store.appStore.setGlobalMessage({ type: 'error', content: this.InputValidUrl });
    }
  }
  onChangeFileUrl({ target: { value } }) {
    this.setState({
      fileUrl: value,
    });
  }
  /**
   * [getCloudDocsContentDom 云文档内嵌页]
   *
   * @return  {[type]}  [return description]
   */
  getCloudDocsContentDom(){
    return (
      <React.Fragment>
        <FwDocs/>
      </React.Fragment>
    );
  }
  getLocalComputerContentDom() {
    if (this.props.operateType === 'add') {
      const uploadFileProps = {
        accept: store.appStore.getSupportFileExtensions,
        showUploadList: false,
        customRequest: this.onUploadFilesForLocalComputer,
        multiple: true,
        beforeUpload: this.onBeforeUploadForLocalComputer,
        onChange: this.onChangeSelectedFiles,
      };

      return (
        <React.Fragment>
          <div className="local-computer-content">
            <div className="header-wrapper">{this.LocalComputer}</div>
            <Dragger {...uploadFileProps}>
              <p className="ant-upload-drag-icon">
                <img src={PDF_FILE} />
              </p>
              <p className="ant-upload-text">{this.DropFileHere}</p>

              {/* <p className="ant-upload-hint">Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files</p> */}
            </Dragger>
            <Upload className="click-upload-file-btn" {...uploadFileProps}>
              <Button size='small' type="primary">{this.ClickToUpload}</Button>
            </Upload>
          </div>
        </React.Fragment>
      );
    }
    if (this.props.operateType === 'open') {
      const { isSpin } = this.state;
      const uploadFileProps = {
        accept: store.appStore.getSupportFileExtensions,
        showUploadList: false,
        customRequest: this.onUploadFilesForLocalComputer,
        multiple: false,
        // beforeUpload: this.onBeforeUploadForLocalComputer,
        onChange: this.onChangeSelectedLocalFile,
      };

      return (
        <React.Fragment>
          <div className="local-computer-content">
            <Spin spinning={isSpin} tip={intl.formatMessage({id: 'Loading.file'})}>
              {/* <div className="header-wrapper">{this.LocalComputer}</div> */}
              <Dragger {...uploadFileProps}>
                <p className="ant-upload-drag-icon">
                  <img src={LOCAL_COMPUTER} />
                </p>
                <p className="ant-upload-text">{this.ClickOrDropFileHere}</p>

                {/* <p className="ant-upload-hint">Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files</p> */}
                {
                  store.appStore.isIncludeFoxitStorage && !store.storageAppStore.isDisableStorage &&
                  <div className='upload-local-document-to-storage' onClick={(e) => {
                    if (e.target.nodeName !== 'A') return;
                    e.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation();
                    
                    store.viewer.pdfui.customs.showPreferences('document');
                    store.userStore.doSendGAEvent({ action: 'Open_file_local_computer_page_preferences_setting', label: 'Open_File', category: 'Foxit_Storage' });
                  }}>{ intl.getHTML('CommonPanel.UploadToStorage') }</div>
                }
              </Dragger>
              <Upload className="click-upload-file-btn" {...uploadFileProps}>
                <Button size='small' type="primary">{this.ChooseFile}</Button>
              </Upload>
            </Spin>
          </div>
        </React.Fragment>
      );
    }
    if (this.props.operateType === 'save') {
      /* const uploadFileProps = {
        accept: 'application/pdf',
        showUploadList: false,
        customRequest: this.onUploadFilesForLocalComputer,
        multiple: false,
        // beforeUpload: this.onBeforeUploadForLocalComputer,
        onChange: this.onChangeSelectedLocalFile,
      }; */

      return (
        <React.Fragment>
          <div className="local-computer-content">
            {/* <div className="header-wrapper">{this.LocalComputer}</div> */}
            <div className="click-download-file-btn-wrapper">
              <p className="ant-upload-drag-icon">
                <img src={LOCAL_COMPUTER} />
              </p>
              <p className="ant-upload-text">{this.SaveToLocalComputer}</p>

              {/* <Button className="click-upload-file-btn"> */}
              <Button onClick={this.props.onSaveToLocalComputer} type="primary">
                {this.Download}
              </Button>
              {/* </Button> */}
              {/* <p className="ant-upload-hint">Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files</p> */}
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
  getUrlContentDom() {
    return (
      <React.Fragment>
        <div className="url-content">
          <div className="header-wrapper">{this.Url}</div>
          <div className="url-input-wrapper">
            <div>{this.EnterThePdfFileUrl}</div>
            <Input onChange={this.onChangeFileUrl} className="url-input" />
          </div>
          <div className="footer-btn-wrapper">
            <Button onClick={this.props.onCancel} className="cancel-btn">
              {this.Cancel}
            </Button>
            <Button onClick={this.onOpenUrlFile} className="open-btn">
              {this.Open}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
  getOneDriveContentDom() {
    return (
      <React.Fragment>
        <div className="drives-content">
          {/* <div className="header-wrapper">{this.OneDrive}</div> */}
          <Drives driveName={ONE_DRIVE} driverTitle={ONE_DRIVE} {...this.commonDrivesProps} />
        </div>
      </React.Fragment>
    );
  }
  getDropboxContentDom() {
    return (
      <React.Fragment>
        <div className="drives-content">
          {/* <div className="header-wrapper">{this.DropBox}</div> */}
          <Drives type="panel" driveName={DROP_BOX} driverTitle={DROP_BOX} {...this.commonDrivesProps} />
        </div>
      </React.Fragment>
    );
  }
  getBoxContentDom() {
    return (
      <React.Fragment>
        <div className="drives-content">
          {/* <div className="header-wrapper">{this.Box}</div> */}
          <Drives type="panel" driveName={BOX} driverTitle={BOX} {...this.commonDrivesProps} />
        </div>
      </React.Fragment>
    );
  }
  getIManageContentDom() {
    return (
      <React.Fragment>
        <div className="drives-content">
          <Drives type="panel" driveName={iManage} driverTitle={iManage} {...this.commonDrivesProps} />
        </div>
      </React.Fragment>
    )
  }
  getGoogleDriveContentDom() {
    return (
      <React.Fragment>
        <div className="drives-content">
          {/* <div className="header-wrapper">{this.GoogleDrive}</div> */}
          <Drives
            driveName={GOOGLE_DRIVE}
            driverTitle={GOOGLE_DRIVE}
            // convertController={this.props.convertController}
            {...this.commonDrivesProps}
          />
        </div>
      </React.Fragment>
    );
  }
  componentDidMount() {
    // this.initTabPans();
    this.onChangeTab(this.props.activeKey);
  }
  onChangeTab = (activeKey) => {
    if (activeKey !== 'Url' && activeKey !== 'LOCAL_COMPUTER') {
      store.driveStore.setDriveName(activeKey);
    }
    switch (activeKey) {
      case 'LOCAL_COMPUTER': 
        store.userStore.doSendGAEvent({ action: 'Open_file_from_local_computer', label: 'Open_File', category: 'Foxit_Storage' });
        break;
      case 'RecentFiles': 
        store.userStore.doSendGAEvent({ action: 'Open_file_from_rencent_files', label: 'Open_File', category: 'Foxit_Storage' });
        break;
      case 'Documents': 
        store.userStore.doSendGAEvent({ action: 'Open_file_from_documents', label: 'Open_File', category: 'Foxit_Storage' });
        break;
    }
    if (this.tabPansArr.length) {
      let currentTab = this.tabPansArr.find( item => item.key === activeKey);
      if (currentTab && currentTab.disabled) {
        return;
      }
    }
    this.setState({
      activeKey
    })
  };
  getActiveContent = (tabPansArr, activeKey) => {
    for (const item of tabPansArr) {
      if (item.key === activeKey) return item.content;
    }
    return null;
  };
  getSaveToFoxitStorageTabPan () {
    const { customInfo } = this.props;
    let { isSpin, docName, isDocumentReady, folderInfo, blobInfoCache } = this.state;
    docName = docName
      || (customInfo && customInfo.fileNameArr && `${customInfo.fileNameArr[0]}.${customInfo.fileNameArr[customInfo.fileNameArr.length - 1]}`)
      || store.docStore.docInfo.fileName;
    const suffix = store.storageAppStore.getSuffix(docName);
    const prevName = store.storageAppStore.getPrevFileName(docName);
    const OnSave = () => {
      const saveToStorage = (blobInfo) => {
        return new Promise((resolve, reject) => {
          const { blob, mimeType } = blobInfo;
          store.storageAppStore.queryFileInFolder(docName, folderInfo.docId).then(res => {
            if (res) {
              const err = intl.get('FoxitStorage.Error.DuplicateName');
              store.appStore.setGlobalMessage({ type: 'error', content: err });
              this.setState({ blobInfoCache: blobInfo });
              reject(err)
              return
            } else {
              this.setState({ blobInfoCache: undefined });
              blob.arrayBuffer().then(buffer => {
                store.storageAppStore.upload(folderInfo.docId, buffer, docName, mimeType, (data) => {
                  store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
                  this.setState({ docName: undefined, folderInfo: undefined, isDocumentReady: undefined, blobInfoCache: undefined });
                  this.props.onCancel && this.props.onCancel();
                  if (this.props.customInfo && this.props.customInfo.isFromExeUpload && store.appStore.isFromServiceModeOfClient) {
                    store.appStore.setServiceModeOfClientInfo(null);
                  }
                  resolve(data);
                })
              }).catch(e => {
                reject(e);
              });
            }
          });
        });
      }
      this.setState({ isSpin: true });
      // 另存为操作
      if (blobInfoCache) {
        return saveToStorage(blobInfoCache).finally(() => {
          this.setState({ isSpin: false });
        });
      }
      if (customInfo && customInfo.getFileInfo) {
        return customInfo.getFileInfo({
          type: 'Storage'
        }).then((blobInfo) => {
          return saveToStorage(blobInfo);
        }).finally(() => {
          this.setState({ isSpin: false });
        });
      }
      // 保存到storage
      store.storageAppStore.saveCurrentDocToFoxitStorage(folderInfo, prevName + '.pdf').then(() => {
        store.appStore.setGlobalMessage({ type: 'success', content: intl.formatMessage({ id: 'UploadingFile.success' }) });
        this.setState({ docName: undefined, folderInfo: undefined });
        this.props.onCancel && this.props.onCancel();
        if (this.props.customInfo && this.props.customInfo.isFromExeUpload && store.appStore.isFromServiceModeOfClient) {
          store.appStore.setServiceModeOfClientInfo(null);
        }
      }).finally(() => {
        this.setState({ isSpin: false });
      });
    }
    return (
      <React.Fragment>
        <Spin spinning={isSpin} tip={intl.formatMessage({id:'FoxitStorage.UploadFiles.Uploading'})}>
          <div className="save-to-foxit-storage-content">
            <div className='storage-content'>
              <StorageTable tabs={['Documents']} pagabled={true} mini={true} multiple={false} actionFileName={false} onReady={()=>{
                this.setState({isDocumentReady: true});
              }} onFolderChange={(data)=>{
                folderInfo = data;
                this.setState({ folderInfo });
              }}></StorageTable>
              <Divider></Divider>
              <div className='fileNameContent'>
                <label>{intl.get('SaveFileForPanel.Modal.FileName')}:</label>
                <Input disabled={!isDocumentReady} defaultValue={prevName} onChange={e => {
                  this.setState({ docName: e.target.value + suffix });
                }} />
              </div>
            </div>
            <footer>
              <Button size="small" type="primary" disabled={!isDocumentReady} onClick={OnSave}>{intl.get('Save')}</Button>
              <Button size="small" onClick={this.props.onCancel} className="cancel-btn">{this.Cancel}</Button>
            </footer>
          </div>
        </Spin>
      </React.Fragment>
    );
  }
  getSaveAndOpenTabPans(tabPansArr) {
    let localOrFoxitTabs = tabPansArr.filter(i=> i.category !== 'otherNet');
    let otherNetTabs = tabPansArr.filter(i=> i.category === 'otherNet');
    let localTitlePanel = { key: 'localTitlePanel', disabled: true,  tab: this.props.operateType === 'open' ? this.OpenLocalTabTitle : this.SaveLocalTabTitle };
    let otherTitlePanel = { key: 'otherTitlePanel', disabled: true,  tab: this.props.operateType === 'open' ? this.OpenOtherTabTitle : this.SaveOtherTabTitle};
    let _panels = [];
    if (localOrFoxitTabs.length) {
      _panels.push(localTitlePanel);
    }
    _panels.push(...localOrFoxitTabs);
    if (otherNetTabs.length) {
      _panels.push(otherTitlePanel);
    }
    _panels.push(...otherNetTabs);
    return _panels;
  }

  render() {
    let tabPansArr = this.initTabPans();
    if(this.props.onlyDrive){
      tabPansArr = tabPansArr.filter(i=>i.key.toLowerCase().includes('google'))
    }

    if (this.props.operateType !== 'add') {
      tabPansArr = this.getSaveAndOpenTabPans(tabPansArr)
    }

    this.tabPansArr = tabPansArr;

    return (
      <React.Fragment>
        <div className="open-save-combine-common-panel-wrapper">
          {this.props.operateType !== 'add' && tabPansArr && (
            <AriaTabs activeKey={this.state.activeKey} onChange={this.onChangeTab} className="open-save-combine-common-panel" tabPosition="left">
              {tabPansArr.map((item) => {
                return (
                  <TabPane disabled={item.disabled} tab={item.tab} key={item.key}>
                    {item.content}
                  </TabPane>
                );
              })}
            </AriaTabs>
          )}
          {this.props.operateType === 'add' && (
            <>
              <div className="open-save-combine-common-panel-wrapper">
                {this.getActiveContent(tabPansArr, this.props.activeKey)}
              </div>
            </>
          )}
        </div>
      </React.Fragment>

    );
  }
}

export default CommonPanel
